/* eslint-disable */
import { FILTER_NEXT_DATE_RANGE_SELECTED } from '../Filters.types';

/**
 * Action to update the next date range based on the `numberOfDays` and the `startDate` in the filters
 * @returns {ActionCreator<FromPayload<null, ActionMeta, FILTER_NEXT_DATE_RANGE_SELECTED>>} The created `Action`
 */
const filtersNextDateRangeSelected = () => ({ fromPayload }) => {
  return fromPayload(null, { debounce: true }, FILTER_NEXT_DATE_RANGE_SELECTED);
};

export default filtersNextDateRangeSelected;
